<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ddYFEb/tc-custom/9781613120491.jpg?1734278294499" alt="This image is the cover for the book Baked Explorations"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Baked Explorations
      </h1>
      <p class="bookDescription body article font2">
        <b>Traditional treats get an innovative twist in these seventy-two recipes from the owners of the famous Baked bakeries.</b><br/>  <br/> In <i>Baked Explorations</i>, Matt Lewis and Renato Poliafito, owners of the acclaimed Baked NYC and Baked Charleston, put a modern spin on America’s most famous sweet treats.<br/>  <br/> From Mississippi Mud Pie to New York’s Black &amp; White Cookie and the classic Devil’s Food Cake with Angel Frosting, these are the desserts that have been passed down for generations, newly updated with Lewis and Poliafito’s signature tongue-in-cheek style—just like Baked’s most in-demand item, also included here, the Sweet and Salty Brownie.<br/>  <br/> They may not be your grandma’s treats, but these new renditions of old favorites will have everyone begging for more.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Matt Lewis, Renato Poliafito, Tina Rupp
      </h2>
      
      <p class="authorDescription body article">Matt Lewis and Renato Poliafito left their day jobs in advertising to open their bakery, Baked, in Brooklyn to immediate praise from fans across the country. They have been featured on <I>Oprah</I>, the <I>Today Show</I>, the Food Network, and the <I>Martha Stewart Show</I>. Other books include <I>Baked</I>, <I>Baked Occasions</I>, <I>Baked Elements</I>, and <I>Baked Explorations</I>. Lewis and Poliafito live in New York City.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Abrams
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?44e0cf0f